<template>
  <div class="row">
    <div class="col-12">
      <product-table />
    </div>
  </div>
</template>

<script>
import ProductTable from "@/views/components/products/table";
export default {
  name: "ProductList",
  components: { ProductTable },
};
</script>
